import type { RawRow } from "../types";

export type RowKind = "blank" | "metadata" | "section" | "content";

const METADATA_KEYS = new Set([
  "サービスID",
  "サービス名",
  "画面ID",
  "画面名",
  "パス",
  "表示条件",
  "共通コンポーネントID",
  "共通コンポーネント名",
]);

const SECTION_HEADERS = new Set([
  "項目定義",
  "データバリデーション",
  "画面遷移",
  "振る舞い",
  "メッセージ",
  "その他",
]);

/**
 * 詳細シート (`画面_*` / `共通_*`) の 1 行を「枠組み行」と「内容行」に分類する。
 *
 * - `blank`    : 全セル空
 * - `metadata` : 行頭が既知メタキー かつ 2 列目に値あり (画面ID | WJ-003 等)
 * - `section`  : 行頭が既知セクション名 (項目定義 / データバリデーション 等)
 * - `content`  : 上記以外 (ヘッダー行 / データ行 / コメント行など)
 *
 * `content` の用途は `DetailSheetParser` 側で判定する (現在のセクションの
 * 期待カラムを全包含する行ならヘッダー、ヘッダー確定後の非空行をヘッダー名で値解決してデータ行として処理)。
 */
export class RowClassifier {
  classify(row: RawRow): RowKind {
    if (isBlank(row)) return "blank";

    const head = row[0]?.trim() ?? "";
    if (METADATA_KEYS.has(head) && hasValue(row[1])) return "metadata";
    if (SECTION_HEADERS.has(head)) return "section";
    return "content";
  }
}

function isBlank(row: RawRow): boolean {
  return row.every((cell) => cell == null || (typeof cell === "string" && cell.trim() === ""));
}

function hasValue(cell: string | null | undefined): boolean {
  return typeof cell === "string" && cell.trim() !== "";
}
